import { createFileRoute, Outlet } from '@tanstack/react-router'
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import { NotFoundContent } from '@/components/NotFoundContent'

export const Route = createFileRoute('/_public')({
  component: PublicLayout,
  notFoundComponent: NotFoundContent,
})

function PublicLayout() {
  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  )
}
